import * as yup from 'yup';
import {lang} from '../../../lang/lang';

export const confirmEmailValidationSchema = () => yup.object().shape({
    email: yup.string().required().email().label(lang.auth.email),
});
